import { ComponentProps, Show } from "solid-js";
import c from "class-c";

import styles from "./Line.module.scss";

declare namespace Line {
  type Props = ComponentProps<"div"> & {
    text?: string;
    // This is necessary when Line is at the top of a container with hidden
    // overflow.
    shiftDown?: boolean;
  };
}

function Line({ text, class: className, shiftDown, ...props }: D<Line.Props>) {
  return (
    <Show
      when={text}
      fallback={
        <div
          class={c`${styles["line"]} ${shiftDown && styles["shift-down"]} ${className}`}
          {...props}
        />
      }
    >
      <div class={c`${styles["line-container"]} ${className}`}>
        <div class={styles["line"]} />
        <main class="text:small-regular">{text}</main>
        <div class={styles["line"]} />
      </div>
    </Show>
  );
}

export default Line;
